import axios from "axios";
import { getToken,setToken } from "./auth";
import {Notification, MessageBox} from 'element-ui'

// create an axios instance
const service = axios.create({
  baseURL: '/eip-mapp-bpm-working-server/',
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 300000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    let token = getToken();
    // let token = "11d6a2e7a1d443a310ced28c7a10c20f";
    if (token) {
      config.headers["keyId"] = token
    }
    return config;
  },
  error => {
    console.log(error); // for debug
    return Promise.reject(error);
  },
);

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    let noConfirmationPrompt = false
    try {
      noConfirmationPrompt = response.config.options.noConfirmationPrompt
    } catch (e) {}
    if (noConfirmationPrompt) {
      console.log('🎈-----dfs-request.js-40-----', response.config.url)
    }
    if (res.code === "0405") {
      if (location.hash.includes('ddFlow') && !noConfirmationPrompt && !window.opendLoginNotification) {
        MessageBox.confirm('当前登录已失效，点击确定刷新并登录！', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          setToken("");
          window.location.reload(true);
        }).catch(() => {
          window.opendLoginNotification = false
        });
        window.opendLoginNotification = true
        return res;
      } else {
        !window.opendLoginNotification && Notification.warning({
          title: "提示",
          message: "系统正在登录中..."
        });
        setToken("");
        setTimeout(() => {
          window.location.reload(true);
        }, 1000)
        window.opendLoginNotification = true
        return
      }
    }
    if (res.code === "0000") {
      res.success = true;
    }
    return res;
  },
  error => {
    console.log("err" + error); // for debug
    return Promise.reject(error);
  },
);
export default service;
